/* Runtime-first config:
   1) window.__ENV (runtime)
   2) process.env (fallback para dev/build antigo)
*/
const fromWindow = (typeof window !== "undefined" && window.__ENV) ? window.__ENV : {};

const get = (k, fallback = "") => {
  if (fromWindow && fromWindow[k] !== undefined && fromWindow[k] !== null && fromWindow[k] !== "") {
    return fromWindow[k];
  }
  // fallback para o modelo antigo (build-time), útil no dev
  const v = (typeof process !== "undefined" && process.env) ? process.env[k] : undefined;
  return (v !== undefined && v !== null) ? v : fallback;
};

export const ENV = {
  // respeitando o seu nome atual (typo incluído)
  VUE_APP_ENVRION_VAR: get("VUE_APP_ENVRION_VAR", ""),

  VUE_APP_AUTH_TOKEN: get("VUE_APP_AUTH_TOKEN", ""),
  VUE_APP_AUTH_TOKEN_FILE: get("VUE_APP_AUTH_TOKEN_FILE", ""),
  VUE_APP_BASE_URL: get("VUE_APP_BASE_URL", ""),
  VUE_APP_URL_FROM_APP_USER: get("VUE_APP_URL_FROM_APP_USER", ""),
  VUE_APP_URL_FROM_DASHBOARD: get("VUE_APP_URL_FROM_DASHBOARD", ""),
};
